// Project

export const PROJECT_NAME = 'SysBeneficio';

// URLs

const PROTOCOL = import.meta.env.PROD ? '' : `https`;
const HOST = import.meta.env.PROD ? '' : import.meta.env.VITE_IP_ADDRESS;
export const API_URL = import.meta.env.PROD ? `/${PROJECT_NAME}/rs` : `${PROTOCOL}://${HOST}/${PROJECT_NAME}/rs`;

export const BASE_NAME = `/${PROJECT_NAME}`;

export const URL_MODULOS = `${API_URL}/modulos`;

export const URL_ACOMPANHAMENTO_PROCESSOS = `${API_URL}/acompanhamento/processos-seletivos`;
export const URL_ACOMPANHAMENTO_ESTATISTICAS = (idProcessoSeletivo) => `${URL_ACOMPANHAMENTO_PROCESSOS}/${idProcessoSeletivo}/estatisticas`;
export const URL_ACOMPANHAMENTO_DOCUMENTOS = (idProcessoSeletivo) => `${URL_ACOMPANHAMENTO_PROCESSOS}/${idProcessoSeletivo}/documentos`;
export const URL_ACOMPANHAMENTO_CONCORRENCIA = (idProcessoSeletivo) => `${URL_ACOMPANHAMENTO_PROCESSOS}/${idProcessoSeletivo}/concorrencia`;

/*
 * Modo de teste do administrativo: abre sem credencial e com TODOS os módulos (como um usuário master).
 * Liga sozinho no `npm run dev`; num build (WAR) só com VITE_ADMIN_SEM_CREDENCIAL=true no .env.
 * Só afeta o menu/rotas do front: os endpoints do back continuam exigindo a credencial.
 */
export const ADMIN_SEM_CREDENCIAL = import.meta.env.DEV || import.meta.env.VITE_ADMIN_SEM_CREDENCIAL === 'true';

// Todos os módulos (ADGERAL.MODULO) do sistema SYSBENEF, usados no modo de teste.
export const TODOS_MODULOS_SYSBENEF = [
    'INSCRICAO', 'EDITINSCRI', 'EDITSTATUS', 'EDITNOME', 'EDITDTNASC', 'CFGERPLINS', 'CFGERFIINS', 'CFATUPSINS',
    'AGENDA', 'CFIMPSEL', 'PROGRAMA', 'HABITACAO', 'MORADIA', 'PROCSEL', 'CFPOSTATEN', 'CFATENDENT', 'CFCADESCAT',
    'CFDISPONIB', 'CFRESPONS', 'CARGASAF', 'PBEST', 'PROUNI', 'PESQCARGAS', 'RCENVEMAIL', 'RELMENU', 'RELCONCBOL'
];

// Qualquer um destes libera o menu Cadastros (e o cadastro de Documento, que não tem módulo próprio).
export const MODULOS_CADASTROS = [
    'PROGRAMA', 'HABITACAO', 'MORADIA', 'PROCSEL', 'CFPOSTATEN', 'CFATENDENT', 'CFDISPONIB', 'CFCADESCAT', 'CFRESPONS'
];

export const URL_PROCESSO_SELETIVO = `${API_URL}/processos-seletivos`;
export const URL_PROCESSO_SELETIVO_ENEM = (id) => `${URL_PROCESSO_SELETIVO}/${id}/enem`;
export const URL_PROCESSO_SELETIVO_VAGAS = (id) => `${URL_PROCESSO_SELETIVO}/${id}/vagas`;

// Inscrições do administrativo (InscricaoAdministrativaService)
export const URL_INSCRICOES = `${API_URL}/inscricoes`;
export const URL_INSCRICOES_PAGINADO = `${URL_INSCRICOES}/paginado`;
export const URL_INSCRICOES_FILTROS = `${URL_INSCRICOES}/filtros`;
export const URL_INSCRICOES_SITUACOES = `${URL_INSCRICOES}/situacoes`;
export const URL_INSCRICOES_ID = (id) => `${URL_INSCRICOES}/${id}`;
export const URL_INSCRICOES_SITUACAO = (id) => `${URL_INSCRICOES}/${id}/situacao`;
export const URL_INSCRICOES_ENEM_INEP = (id) => `${URL_INSCRICOES}/${id}/enem-inep`;
export const URL_INSCRICOES_PESSOAS = `${URL_INSCRICOES}/pessoas`;
export const URL_INSCRICOES_PESSOA_DADOS = (idPessoa) => `${URL_INSCRICOES}/pessoas/${idPessoa}/dados`;
export const URL_INSCRICOES_CARGA_PROUNI = `${URL_INSCRICOES}/carga-prouni`;
export const URL_INSCRICOES_ALUNO = (codigoAluno) => `${URL_INSCRICOES}/alunos/${codigoAluno}`;
export const URL_INSCRICOES_APOIO_PROCESSOS = `${URL_INSCRICOES}/apoio/processos-seletivos`;
export const URL_INSCRICOES_APOIO_PROCESSO = (id) => `${URL_INSCRICOES_APOIO_PROCESSOS}/${id}`;
export const URL_INSCRICOES_APOIO_PS_INSCRICOES = `${URL_INSCRICOES}/apoio/ps-inscricoes`;
export const URL_INSCRICOES_APOIO_ATENDENTES = `${URL_INSCRICOES}/apoio/atendentes`;
export const URL_INSCRICOES_APOIO_TIPOS_BOLSA = `${URL_INSCRICOES}/apoio/tipos-bolsa`;
export const URL_INSCRICOES_APOIO_DEFICIENCIAS = `${URL_INSCRICOES}/apoio/deficiencias`;
export const URL_INSCRICOES_APOIO_ENEM_RESULTADO = `${URL_INSCRICOES}/apoio/enem-resultado`;

// Arquivos das inscrições: fichas, planilhas e atualização do PS (InscricaoArquivoService)
export const URL_INSCRICOES_ARQUIVOS = `${API_URL}/inscricoes-arquivos`;
export const URL_INSCRICOES_ARQUIVOS_FICHA = (id) => `${URL_INSCRICOES_ARQUIVOS}/inscricoes/${id}/ficha`;
export const URL_INSCRICOES_ARQUIVOS_PROCESSOS = `${URL_INSCRICOES_ARQUIVOS}/processos-seletivos`;
export const URL_INSCRICOES_ARQUIVOS_PLANILHA = (idProcessoSeletivo) => `${URL_INSCRICOES_ARQUIVOS_PROCESSOS}/${idProcessoSeletivo}/planilha`;
export const URL_INSCRICOES_ARQUIVOS_FICHAS = (idProcessoSeletivo) => `${URL_INSCRICOES_ARQUIVOS_PROCESSOS}/${idProcessoSeletivo}/fichas`;
export const URL_INSCRICOES_ARQUIVOS_ATUALIZAR_PS = (idProcessoSeletivo) => `${URL_INSCRICOES_ARQUIVOS_PROCESSOS}/${idProcessoSeletivo}/atualizar-ps`;

// Avaliação de documentos da inscrição (AvaliacaoDocumentoService)
export const URL_AVALIACAO_DOCUMENTOS = `${API_URL}/avaliacao-documentos`;
export const URL_AVALIACAO_DOCUMENTOS_INSCRICAO = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}`;
export const URL_AVALIACAO_DOCUMENTOS_TIPOS = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/documentos-processo`;
export const URL_AVALIACAO_DOCUMENTOS_PENDENCIAS = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/pendencias`;
export const URL_AVALIACAO_DOCUMENTOS_EMAIL_PENDENCIAS = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/email-pendencias`;
export const URL_AVALIACAO_DOCUMENTOS_EMAIL_PENDENCIAS_PREVIA = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/email-pendencias/previa`;
export const URL_AVALIACAO_DOCUMENTOS_ZIP = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/zip-aprovados`;
export const URL_AVALIACAO_DOCUMENTOS_ZIP_PESSOAS = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/zip-aprovados/pessoas`;
export const URL_AVALIACAO_DOCUMENTOS_PLANILHA = (id) => `${URL_AVALIACAO_DOCUMENTOS}/inscricoes/${id}/planilha`;
export const URL_AVALIACAO_DOCUMENTOS_ANEXO = (idAnexo) => `${URL_AVALIACAO_DOCUMENTOS}/anexos/${idAnexo}`;
export const URL_AVALIACAO_DOCUMENTOS_ARQUIVO = (idAnexo) => `${URL_AVALIACAO_DOCUMENTOS}/anexos/${idAnexo}/arquivo`;
export const URL_AVALIACAO_DOCUMENTOS_AVALIAR = (idAnexo) => `${URL_AVALIACAO_DOCUMENTOS}/anexos/${idAnexo}/avaliacao`;
export const URL_AVALIACAO_DOCUMENTOS_AVALIACAO = (idAvaliacao) => `${URL_AVALIACAO_DOCUMENTOS}/avaliacoes/${idAvaliacao}`;

// Cadastros básicos do administrativo (Programa, Tipo de Habitação, Tipo de Moradia e Documento)
export const URL_PROGRAMAS = `${API_URL}/programas`;
export const URL_TIPOS_HABITACAO = `${API_URL}/tipos-habitacao`;
export const URL_TIPOS_MORADIA = `${API_URL}/tipos-moradia`;
export const URL_DOCUMENTOS_CADASTRO = `${API_URL}/documentos`;

// Cadastro de Processo de Seleção do administrativo (abas Geral, Inscrição, ..., Carga) e listas de apoio
export const URL_PROCESSOS_SELECAO = `${API_URL}/processos-selecao`;
export const URL_PROCESSOS_SELECAO_NOVO = `${URL_PROCESSOS_SELECAO}/novo`;
export const URL_PROCESSOS_SELECAO_ID = (id) => `${URL_PROCESSOS_SELECAO}/${id}`;
export const URL_PROCESSOS_SELECAO_APOIO_PROGRAMAS = `${URL_PROCESSOS_SELECAO}/apoio/programas`;
export const URL_PROCESSOS_SELECAO_APOIO_CAMPI = `${URL_PROCESSOS_SELECAO}/apoio/campi`;
export const URL_PROCESSOS_SELECAO_APOIO_CAMPI_REMETENTE = `${URL_PROCESSOS_SELECAO}/apoio/campi-remetente`;
export const URL_PROCESSOS_SELECAO_APOIO_CURSOS = `${URL_PROCESSOS_SELECAO}/apoio/cursos`;
export const URL_PROCESSOS_SELECAO_APOIO_TURNOS = `${URL_PROCESSOS_SELECAO}/apoio/turnos`;
export const URL_PROCESSOS_SELECAO_APOIO_ENEMS = `${URL_PROCESSOS_SELECAO}/apoio/enems`;
export const URL_PROCESSOS_SELECAO_APOIO_TIPOS_CALENDARIO = `${URL_PROCESSOS_SELECAO}/apoio/tipos-calendario`;
export const URL_PROCESSOS_SELECAO_APOIO_DOCUMENTOS = `${URL_PROCESSOS_SELECAO}/apoio/documentos`;
export const URL_PROCESSOS_SELECAO_APOIO_PROCESSOS_VESTIBULAR = `${URL_PROCESSOS_SELECAO}/apoio/processos-vestibular`;
export const URL_PROCESSOS_SELECAO_IMPORTAR_CARGAS = `${URL_PROCESSOS_SELECAO}/apoio/cargas/importar`;
// Planilha modelo da carga de candidatos, servida estaticamente pela aplicação (WebContent/resources/templates).
export const URL_MODELO_CARGA_PROCESSO_SELECAO = `${API_URL.replace(/\/rs$/, '')}/resources/templates/modelo_carga_processo_seletivo.xlsx`;

// Coordenadores da Central de Bolsas, Responsáveis e busca de funcionários (cadastros de atendimento)
export const URL_FUNCIONARIOS_PAGINADO = `${API_URL}/funcionarios/paginado`;
export const URL_COORDENADORES = `${API_URL}/coordenadores`;
export const URL_COORDENADORES_CAMPI = `${URL_COORDENADORES}/apoio/campi`;
export const URL_RESPONSAVEIS = `${API_URL}/responsaveis`;
export const URL_ATENDENTES = `${API_URL}/atendentes`;
export const URL_ATENDENTES_PESSOAS = `${URL_ATENDENTES}/apoio/pessoas`;

// Carga SAF (Pbest e outros, Prouni/Fies e pesquisa das cargas)
export const URL_CARGAS_SAF = `${API_URL}/cargas-saf`;
export const URL_CARGAS_SAF_APOIO_PROCESSOS_SELECAO = `${URL_CARGAS_SAF}/apoio/processos-seletivos`;
export const URL_CARGAS_SAF_PBEST_MODELO = `${URL_CARGAS_SAF}/pbest/modelo`;
export const URL_CARGAS_SAF_PBEST_LEITURA = `${URL_CARGAS_SAF}/pbest/leitura`;
export const URL_CARGAS_SAF_PBEST = `${URL_CARGAS_SAF}/pbest`;
export const URL_CARGAS_SAF_PROUNI_CONSOLIDACAO = `${URL_CARGAS_SAF}/prouni/consolidacao`;
export const URL_CARGAS_SAF_PROUNI_CARGA = `${URL_CARGAS_SAF}/prouni/carga`;
export const URL_CARGAS_SAF_PROUNI_EXCEL = `${URL_CARGAS_SAF}/prouni/excel`;
export const URL_CARGAS_SAF_PESQUISA = `${URL_CARGAS_SAF}/pesquisa`;
export const URL_CARGAS_SAF_PESQUISA_PROCESSOS_SELECAO = `${URL_CARGAS_SAF_PESQUISA}/processos-selecao`;

// Enviar e-mails (administrativo)
export const URL_ENVIO_EMAILS = `${API_URL}/envio-emails`;
export const URL_ENVIO_EMAILS_PROCESSOS_SELECAO = `${URL_ENVIO_EMAILS}/apoio/processos-selecao`;
export const URL_ENVIO_EMAILS_SITUACOES = `${URL_ENVIO_EMAILS}/apoio/situacoes`;
export const URL_ENVIO_EMAILS_INSCRICOES = `${URL_ENVIO_EMAILS}/inscricoes`;
export const URL_ENVIO_EMAILS_MODELO = `${URL_ENVIO_EMAILS}/modelo`;

// Relatórios (administrativo; saída em arquivo .xls)
export const URL_RELATORIO = `${API_URL}/relatorio`;
export const URL_RELATORIO_TERMOS_CONCESSAO = `${URL_RELATORIO}/termos-concessao`;
export const URL_RELATORIO_TERMOS_CONCESSAO_PERIODOS = `${URL_RELATORIO_TERMOS_CONCESSAO}/periodos`;
export const URL_RELATORIO_CADASTRO_BOLSISTAS = `${URL_RELATORIO}/cadastro-bolsistas`;

export const URL_INSCRICAO_IDENTIFICAR = `${API_URL}/inscricao/identificar`;

export const URL_INSCRICAO_SALVAR = `${API_URL}/inscricao/salvar`;

export const URL_INSCRICAO_ATUALIZAR = `${API_URL}/inscricao/atualizar`;

export const URL_INSCRICAO_FICHA = `${API_URL}/inscricao/ficha`;

export const URL_INSCRICAO_CREDENCIAL = `${API_URL}/inscricao/credencial`;

export const URL_ENDERECO = `${API_URL}/endereco`;

export const URL_GRAU_PARENTESCO = `${API_URL}/grau-parentesco`;

export const URL_TIPO_MORADIA = `${API_URL}/tipo-moradia`;
export const URL_TIPO_HABITACAO = `${API_URL}/tipo-habitacao`;
export const URL_FORMACOES = `${API_URL}/formacoes`;
export const URL_ENDERECO_TIPOS = `${URL_ENDERECO}/tipos`;
export const URL_ENDERECO_ESTADOS = `${URL_ENDERECO}/estados`;
export const URL_ENDERECO_CIDADES = `${URL_ENDERECO}/cidades`;
export const URL_ENDERECO_CEPS = `${URL_ENDERECO}/ceps`;
export const URL_ESTADO_CIVIL = `${API_URL}/estado-civil`;
export const URL_RACA = `${API_URL}/raca`;
export const URL_NACIONALIDADE = `${API_URL}/nacionalidade`;

export const MESSAGE_INFO = 'info';
export const MESSAGE_ALERT = 'warning';
export const MESSAGE_ERROR = 'error';
export const MESSAGE_SUCCESS = 'success';
export const MESSAGE_WARNING = 'warning';
